import { apiClient } from "../api/apiClient";
import QueryHelpers from "../../utils/queryHelpers";

const getAllUsers = (args) => {
    const params = {
        page: args?.page ?? 1,
        pageSize: args?.pageSize ?? 10,
        search: args?.search ?? ''
    };

    const query = QueryHelpers.buildQueryString(params);
    return apiClient.get(`/users?${query}`, { requiresAuth: true });
};

const getUserById = (id) =>
    apiClient.get(`/users/${id}`, { requiresAuth: true });

const getUserEvents = (userId, args) => {
    const params = {
        page: args?.page ?? 1,
        pageSize: args?.pageSize ?? 10
    };

    const query = QueryHelpers.buildQueryString(params);
    return apiClient.get(`/users/${userId}/events?${query}`, { requiresAuth: true });
};

export default {
    getAllUsers,
    getUserById,
    getUserEvents
};
